import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  Typography,
} from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import React from "react";

export interface FinesPaymentDialogProps {
  dialogProps: {
    open: boolean;
    onClose: () => void;
    onTransitionExited: () => void;
  };
  paymentProvider: string;
  paymentUrl: string;
  paymentToken: string;
  isIframeLoading: boolean;
  hasIframeError: boolean;
}

export const FinesPaymentDialog: React.FC<FinesPaymentDialogProps> = ({
  dialogProps,
  paymentProvider,
  paymentUrl,
  paymentToken,
  isIframeLoading,
  hasIframeError,
}) => {
  const { translate } = useLanguage();
  const formRef = React.useRef<HTMLFormElement>(null);

  return (
    <Dialog {...dialogProps} maxWidth="md" fullWidth>
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6">
          {translate("payFinesWith")} {paymentProvider}
        </Typography>

        {hasIframeError && (
          <Button onClick={dialogProps.onClose}>{translate("close")}</Button>
        )}
      </Box>
      <Box sx={{ width: "100%", minHeight: "756px", position: "relative" }}>
        {isIframeLoading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1, // loading spinner must be behind the iframe
            }}
          >
            <CircularProgress />
          </Box>
        )}

        {hasIframeError ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
          >
            <Alert severity="error">
              {translate("finesPaymentConnectionError")}
            </Alert>
          </Box>
        ) : (
          <>
            <iframe
              id="hostedPaymentIFrame"
              name="hostedPaymentIFrame"
              title="Card Payment"
              style={{
                width: "100%",
                height: "756px",
                border: "none",
                position: "relative",
                zIndex: 2, // iframe is in front so the browser does not suspend the js
                opacity: isIframeLoading ? 0.01 : 1, // nearly invisible while loading so we can see the spinner behind it, opaque enough that mobile browsers don't suspend it
                pointerEvents: isIframeLoading ? "none" : "auto", // prevent user from accidentally clicking the invisible form
              }}
            />
            <form
              ref={formRef}
              id="tokenForm"
              method="post"
              action={paymentUrl}
              target="hostedPaymentIFrame"
              style={{ display: "none" }}
            >
              <input type="hidden" name="token" value={paymentToken} />
            </form>
          </>
        )}
      </Box>
    </Dialog>
  );
};
